import { Agency } from '../../../interfaces/Advisors';
import { AgencyDto } from '../../../interfaces/dtos/AdvisorsDto';
import { toTitleCase } from '../../../utils/toTitleCase';
import transformPhones from './transformPhones';

export default function transformAgency(dto: AgencyDto): Agency {
  if (!dto) return undefined;
  return {
    email: dto.email ?? '',
    name: toTitleCase(dto.name),
    phones: transformPhones(dto.phones),
    address: dto.address ?? '',
    address2: dto.address2 ?? '',
    city: toTitleCase(dto.city),
    postalCode: dto.postalCode ?? '',
    state: toTitleCase(dto.state),
  };
}
